'use client'

import Link from 'next/link'

export default function Header() {
  const menuItems = [
    { href: '#about-me', label: 'About Me' },
    { href: '#training-approach', label: 'Training Approach' },
    { href: '#testimonials', label: 'Testimonials' },
    { href: '#pricing', label: 'Pricing' },
    { href: '#faq', label: 'FAQs' },
    { href: '#contact', label: 'Contact' },
  ]

  return (
    <>
      <input type="checkbox" id="menu-toggle" className="hidden" />

      {/* Mobile Menu Overlay */}
      <div className="menu-overlay fixed inset-[0] z-40 bg-[#020E20] desktop:hidden">
        <div className="flex h-full flex-col items-center justify-start pt-[120px]">
          {/* Navigation Menu */}
          <nav className="flex flex-col items-center gap-[32px]">
            {menuItems.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className="text-[18px] font-semibold text-FFFFFF uppercase transition-colors hover:text-[#88EFFF]"
                onClick={() => {
                  // Close menu when link is clicked
                  const checkbox = document.getElementById(
                    'menu-toggle',
                  ) as HTMLInputElement
                  if (checkbox) checkbox.checked = false
                }}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>
      </div>

      <header className="fixed top-[0] left-[0] z-50 w-[100vw] p-[20px]">
        {/* Desktop Layout */}
        <div className="hidden w-full justify-between desktop:flex">
          <Link href="#hero" className="h-[40px]">
            <img src="/logo.svg" alt="XnnFit Logo" className="h-[100%]" />
          </Link>
          <nav className="flex items-center gap-[32px]">
            {menuItems.map((item) => (
              <Link
                key={item.href}
                href={item.href}
                className="text-[14px] font-semibold text-FFFFFF uppercase transition-colors hover:text-[#88EFFF]"
              >
                {item.label}
              </Link>
            ))}
          </nav>
        </div>

        {/* Mobile Layout */}
        <div className="grid h-[40px] grid-cols-2 desktop:hidden">
          <Link href="#hero" className="h-[40px] justify-self-start">
            <img src="/logo.svg" alt="XnnFit Logo" className="h-[100%]" />
          </Link>
          <div className="relative justify-self-end">
            {/* Hamburger icon (shown when menu closed) */}
            <label
              htmlFor="menu-toggle"
              className="menu-label-hamburger flex aspect-square h-[100%] cursor-pointer flex-col items-center justify-center space-y-1"
            >
              <div className="h-1 w-[55%] rounded-sm bg-FFFFFF"></div>
              <div className="h-1 w-[75%] rounded-sm bg-FFFFFF"></div>
              <div className="h-1 w-[45%] rounded-sm bg-FFFFFF"></div>
            </label>

            {/* Close icon (shown when menu open) */}
            <label
              htmlFor="menu-toggle"
              className="menu-label-close flex aspect-square h-[100%] cursor-pointer items-center justify-center"
            >
              <img
                src="/close.svg"
                alt="Close menu"
                className="h-[24px] w-[24px]"
              />
            </label>
          </div>
        </div>
      </header>
    </>
  )
}
